import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { RiskItem } from '../risk/components/RiskItem';
import { Loading } from '../../shared/components/Loading';
import { styled } from '@mui/styles';
import { ButtonDefault } from '../../shared/components/ButtonDefault';
import { RiskCustomItem } from '../risk/components/RIskCustomItem';
import {
  Risk,
  RisksDocument,
  RiskStatus,
  useRisksLazyQuery,
  useSelectedRiskMutation,
} from '../../shared/types/generated';

const StyledButton = styled(ButtonDefault)({
  borderRadius: '5px!important',
  backgroundColor: '#44DD29!important',
  border: 'none!important',
  color: 'white!important',
  '&:disabled': {
    backgroundColor: '#44DD29!important',
  },
  height: 40,
});

export const SettingRisk: React.FC = () => {
  const [selectedRisk, setSelectedRisk] = useState<Risk | undefined | null>(
    undefined,
  );


  const [callRisks, { loading, data }] = useRisksLazyQuery({
    onCompleted: (datum) => {
      setSelectedRisk(datum.risks?.items?.find((item) => item?.status === RiskStatus.Active));
    },
  });

  const [updateRisk, { loading: updateLoading }] = useSelectedRiskMutation({
    awaitRefetchQueries:true,
    refetchQueries:[RisksDocument],
    onCompleted: () => {
      callRisks();
    },
  });
  useEffect(() => {
    callRisks();
  }, [callRisks]);


  if (loading) return <Loading />;

  const risks = (data?.risks?.items || []) as Risk[];

  console.log({ risks });

  return (
    <Grid
      container
      direction='row'
      justifyContent='center'
      alignItems='center'
      px={'10px'}
    >
      <Grid item sm={10} marginTop={'50px'}>
        <Grid container spacing={2}>
          <Grid item xs={12} display={'flex'} justifyContent={'center'}>
            <Typography fontWeight={700} fontSize={18} textAlign={'center'}>
              Choose your risk profile
            </Typography>
          </Grid>
          <Grid item xs={12} display={'flex'} justifyContent={'center'}>
            <Typography fontSize={12} textAlign={'center'}>
              Select your risk based on your account capital
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Grid
              paddingTop={'20px'}
              container
              columnSpacing={2}
              rowSpacing={2}
              direction='row'
              justifyContent='center'
              alignItems='center'
            >
              {risks.map((risk) => {
                if (risk.is_editable) {

                  const currentRisk = selectedRisk?.id === risk.id ? selectedRisk : risk;
                  return (
                    <Grid item md={3} xs={12}>
                      <RiskCustomItem
                        risk={currentRisk}
                        onSelected={(selected) => setSelectedRisk(selected)}
                        selected={selectedRisk}
                        onChangeValue={(value) => {
                          if (isNaN(parseFloat(value))) return null;
                          setSelectedRisk({
                            ...selectedRisk,
                            value: parseFloat(value),
                          });
                        }}
                      />
                    </Grid>
                  );
                }
                return (
                  <Grid item md={3} xs={12}>
                    <RiskItem
                      risk={risk}
                      onSelected={(selected) => setSelectedRisk(selected)}
                      selected={selectedRisk}
                    />
                  </Grid>
                );
              })}
            </Grid>
            <Grid
              item
              xs={12}
              display={'flex'}
              justifyContent={'center'}
              sx={{ marginTop: { xs: 2, md: 4 } }}
            >
              <StyledButton
                variant='contained'
                color='secondary'
                isLoading={updateLoading}
                onClick={() => {
                  const datumRisk = selectedRisk?.is_editable ? {
                    value: selectedRisk.value,
                  } : {};

                  updateRisk({
                    variables: {
                      where: {
                        id: selectedRisk?.id,
                      },
                      data: datumRisk,
                    },
                  });
                }}
                sx={{ width: { xs: '100%!important', md: 180 } }}
              >
                UPDATE
              </StyledButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};
